import { twMerge } from 'tailwind-merge';

import { getDefaultImageProperties, getTestProps } from '../../lib/helpers';

interface AvatarProps {
  /**
   * User initials
   */
  userInitials?: string;
  /**
   * Avatar image url
   */
  imageUrl?: string;
  /**
   * Additional container classes
   */
  additionalClasses?: string;
  /**
   * Avatar test id
   */
  testId?: string;
}

const Avatar = ({
  userInitials = '',
  imageUrl = '',
  testId = '',
  additionalClasses = '',
}: AvatarProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center justify-center w-9 h-9 rounded-full text-xl text-white font-semibold',
        'bg-blue-50 text-blue cursor-default overflow-hidden dark:bg-blue-900 dark:text-blue-300',
        additionalClasses,
      )}
      {...getTestProps(testId, 'avatar-container')}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          className="object-cover h-full w-full"
          alt={''}
          {...getDefaultImageProperties()}
          {...getTestProps(testId, 'avatar-image')}
        />
      ) : (
        userInitials
      )}
    </div>
  );
};

export default Avatar;
